import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const UPDATE_DOCUMENT_REQUEST = 'UPDATE_DOCUMENT_REQUEST'
export const UPDATE_DOCUMENT_SUCCESS = 'UPDATE_DOCUMENT_SUCCESS'
export const UPDATE_DOCUMENT_FAILURE = 'UPDATE_DOCUMENT_FAILURE'

export const updateDocumentData = (identity, id, data = {}) => ({
  [CALL_API]: {
    endpoint: `/api/identities/${identity}/documents/${id}/`,
    types: [UPDATE_DOCUMENT_REQUEST, UPDATE_DOCUMENT_SUCCESS, UPDATE_DOCUMENT_FAILURE],
    method: 'PATCH',
    tokenType: API_JWT_TOKEN_NAME,
    body: data,
  },
})
